/**
 * 로케일 기본값 — 서버·클라가 함께 쓰는 최소 단위.
 *
 * `@/shared/lib/seo` 는 메타데이터·sitemap 용 상수까지 들고 있어 클라 번들에 넣기엔 무겁다.
 * 로케일 정규화만 필요한 클라 코드(리뷰 캐시 키 등)가 그 무게를 지지 않도록 여기로 분리했다.
 * seo 모듈이 그대로 재수출하므로 기존 import 경로는 계속 유효하다.
 */
export const DEFAULT_LOCALE = "ko"
export const SUPPORTED_LOCALES = ["ko", "en", "cn", "jp"] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const normalizeLocale = (locale: string): SupportedLocale => {
  if (SUPPORTED_LOCALES.includes(locale as SupportedLocale)) {
    return locale as SupportedLocale
  }
  return DEFAULT_LOCALE
}
